import fetchClient from '../utils/fetchClient';

/**
 * Лайкнуть открытку
 * @param {number} relationId - ID открытки
 * @param {number} userId - ID пользователя
 * @returns {Promise<Object>} Результат операции
 */
export const likePostcard = async (relationId, userId) => {
    try {
        const response = await fetchClient.post(`/image_relations_votes/${relationId}/like`, {
            user_id: userId
        });
        return response.data;
    } catch (error) {
        console.error('Ошибка при лайке открытки:', error);
        throw error;
    }
};

/**
 * Отклонить открытку
 * @param {number} relationId - ID открытки
 * @param {number} userId - ID пользователя
 * @returns {Promise<Object>} Результат операции
 */
export const rejectPostcard = async (relationId, userId) => {
    try {
        const response = await fetchClient.post(`/image_relations_votes/${relationId}/reject`, {
            user_id: userId
        });
        return response.data;
    } catch (error) {
        console.error('Ошибка при отклонении открытки:', error);
        throw error;
    }
};

/**
 * Получить голос пользователя для открытки
 * @param {number} relationId - ID открытки
 * @param {number} userId - ID пользователя
 * @returns {Promise<Object>} Информация о голосе
 */
export const getUserVote = async (relationId, userId) => {
    try {
        const response = await fetchClient.get(`/image_relations_votes/${relationId}/user-vote?user_id=${userId}`);
        return response.data;
    } catch (error) {
        console.error('Ошибка при получении голоса пользователя:', error);
        throw error;
    }
};
